import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { AbstractFieldComponent, ReversalType } from '../../../../shared/models/amway/index';
import { Modal } from 'ngx-modal';

@Component({
  templateUrl: './deactivate-field.component.html'
})
export class DeactivateFieldComponent extends AbstractFieldComponent implements OnInit {

  @Input() params;
  @ViewChild('modal') modal: Modal;
  type = ReversalType.REGISTRATION;

  constructor() {
    super();
  }

  ngOnInit() {
    this.modal.open();
  }
}
